import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PagedResponse } from '@shared/models/paged-response';
import { PageEvent } from '@shared/models/page-event';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from '@shared/apis';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';
import { FormControl } from '@angular/forms';
import { SpinnerService } from '@shared/services/spinner.service';
import { AuthService } from '@core/auth/auth.service';
import Configs from '@shared/constants/configs';
import { Options } from '@shared/models/options';
import { environment } from '@env/environment';
import { Constants } from '@shared/constants/constants';
import { PurchasePlace } from '@shared/models/purchase-place';
import { PlaceEditComponent } from '@routes/purchase-place/place-edit/place-edit.component';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-place',
  templateUrl: './place.component.html',
  styleUrls: ['./place.component.scss']
})
export class PlaceComponent implements OnInit {

  @Output() detailUpdateEvent = new EventEmitter();

  readonly configs = Configs;
  readonly constants = Constants;
  readonly backend = environment.api.backend;

  pagedResponse: PagedResponse;

  query: any;
  q: any;
  searchText = new FormControl(null);

  purchasePlaces!: PurchasePlace[];
  selectedData!: PurchasePlace;

  bsModalRef: BsModalRef;
  isAdminViewerRole: boolean;

  constructor(
    private modalService: BsModalService,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private apiService: ApiService,
  ) {
    this.isAdminViewerRole = this.authService.checkHasAdminViewerRole();
  }

  ngOnInit(): void {
    this.showList();

    this.searchText.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(text => {
        this.q = text;
        this.showList();
      });
  }

  onPageEvent(pageEvent: PageEvent) {
    this.showList(pageEvent);
  }

  showList(pageEvent?: PageEvent) {
    this.spinnerService.start();
    this.query = { company: `${ this.authService.getCurrentCompany() }` };
    this.apiService.purchasePlace.getPurchasePlaces(pageEvent, this.q, this.query)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.pagedResponse = res;
        this.purchasePlaces = res.docs.map((m) => {
          return m;
        });
      }, err => Utils.showError(err));
  }

  openPurchasePlaceEdit(purchasePlaceDetail?) {
    const initialState = {
      title: purchasePlaceDetail ? 'Edit Purchase Place' : 'Create Purchase Place',
      saveButtonLabel: purchasePlaceDetail ? 'Update' : 'Create',
      purchasePlaceInfo: purchasePlaceDetail,
      id: purchasePlaceDetail ? purchasePlaceDetail._id : null,
    }

    this.bsModalRef = this.modalService.show(PlaceEditComponent, { initialState, class: 'modal-lg' });
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        this.showList();
      }
    });
  }

  deletePurchasePlace(purchasePlaceCode) {
    Swal.fire({
      title: `Are you sure to delete the this Purchase Place ${ purchasePlaceCode }?`,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        this.apiService.purchasePlace.deletePurchasePlace(purchasePlaceCode)
          .subscribe(res => {
            if (res) {
              this.showList()
            }
            Swal.fire('Deleted!', '', 'success');
          }, err => Utils.showError(err));
      } else if (result.isDenied) {
        Swal.fire('Canceled!', '', 'info');
      }
    });
  }

  options() {
    const opt: Options = {
      q: this.q,
      query: this.query,
    };
    return opt;
  }
}
